import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressTrackingDashboard = ({ candidates }) => {
  const allCandidates = [
    {
      id: 1,
      employeeName: 'John Kila',
      position: 'Senior Compliance Officer',
      stage: 'Pre-Boarding',
      completionRate: 45,
      status: 'in-progress'
    },
    {
      id: 2,
      employeeName: 'Mary Tau',
      position: 'HR Coordinator',
      stage: 'First Day',
      completionRate: 75,
      status: 'in-progress'
    },
    {
      id: 3,
      employeeName: 'Peter Wari',
      position: 'Payroll Specialist',
      stage: 'First Week',
      completionRate: 90,
      status: 'in-progress'
    },
    {
      id: 4,
      employeeName: 'Sarah Konga',
      position: 'IT Support Specialist',
      stage: '90-Day Milestone',
      completionRate: 95,
      status: 'in-progress'
    }
  ];

  const getStatusColor = (completionRate) => {
    if (completionRate >= 90) return 'text-green-600';
    if (completionRate >= 50) return 'text-amber-600';
    return 'text-red-600';
  };

  const getProgressBarColor = (completionRate) => {
    if (completionRate >= 90) return 'bg-green-500';
    if (completionRate >= 50) return 'bg-amber-500';
    return 'bg-red-500';
  };

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="bg-emerald-100 p-2 rounded-lg">
          <Icon name="BarChart3" size={24} className="text-emerald-600" />
        </div>
        <h2 className="text-xl font-bold text-gray-900">Progress Tracking Dashboard</h2>
      </div>

      {/* Progress Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
                Employee
              </th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
                Position
              </th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
                Stage
              </th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">
                Progress
              </th>
              <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {allCandidates?.map(candidate => (
              <tr key={candidate?.id} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-3 px-4">
                  <p className="text-sm font-semibold text-gray-900">
                    {candidate?.employeeName}
                  </p>
                </td>
                <td className="py-3 px-4">
                  <p className="text-sm text-gray-600">{candidate?.position}</p>
                </td>
                <td className="py-3 px-4">
                  <span className="px-2 py-1 bg-emerald-100 text-emerald-700 text-xs rounded">
                    {candidate?.stage}
                  </span>
                </td>
                <td className="py-3 px-4">
                  <div className="flex items-center gap-3">
                    <div className="flex-1 bg-gray-200 rounded-full h-2">
                      <div
                        className={`h-2 rounded-full transition-all ${getProgressBarColor(
                          candidate?.completionRate
                        )}`}
                        style={{ width: `${candidate?.completionRate}%` }}
                      />
                    </div>
                    <span
                      className={`text-sm font-bold ${getStatusColor(
                        candidate?.completionRate
                      )}`}
                    >
                      {candidate?.completionRate}%
                    </span>
                  </div>
                </td>
                <td className="py-3 px-4 text-center">
                  <Icon
                    name={candidate?.completionRate >= 90 ? 'CheckCircle' : 'Clock'}
                    size={20}
                    className={getStatusColor(candidate?.completionRate)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Legend */}
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Status Legend</h3>
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-green-500" />
            <span className="text-xs text-gray-600">Completed (90%+)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-amber-500" />
            <span className="text-xs text-gray-600">In Progress (50-89%)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-red-500" />
            <span className="text-xs text-gray-600">Overdue (&lt;50%)</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressTrackingDashboard;